<template>
  <div class="message-lab-request">
    <div class="smd-panel smd-form__row m-b-10"
         @click="viewPrescription">
      <span class="ns-icon-ico013"></span>
      <p class="Title3">Lab Request</p>
    </div>
    <div v-if="enableActions" class="smd-form__row m-b-5">
      <text-string label-id="txt1410"/>
    </div>
    <div v-if="enableActions" class="actions">
      <smd-btn type="button" section="4" variant="green-enabled" @click="book">
        <div class="logo">
          <img src="@/assets/images/img007.png" alt="Hi-pres Logo">
        </div>
        <text-string :label-id="mainActionLabelId"/>
      </smd-btn>
      <smd-btn type="button" section="4" variant="unselected" @click="goToServices">
        <text-string label-id="txt1412"/>
      </smd-btn>
    </div>
    <p class="Label1 gray-400 timestamp">{{ formattedTime }}</p>
  </div>
</template>

<script>
  import GetElementString from "@/mixins/get-element-string";
  import HpLogo from "@/assets/images/img007.png"
  import Routes, {
    MESSAGE_DOCTOR_PARAM,
    MESSAGE_PATIENT_ID_PARAM,
    SERVICES_ROUTE,
  } from "@/router/routes";

  import TitleMixin from "@/mixins/title-mixin";
  import ToastMixin from '@/mixins/toast-mixin';
  import LabRequestCouponMixin from "@/mixins/lab-request-coupon-mixin";
  import ShowModalInstructionsMixin from "@/mixins/show-modal-instructions-mixin";

  import PreviewFileType from "@/reference/preview-file-type";
  import {mapGetters} from "vuex";
  import {GETTER_DOCTOR_PATIENT_PARTNER} from "@/store/types";
  import {formatDate} from '@/utils/dates';
  import {HIPRES_INSTRUCTION_ITEM, MODAL_LOCAL_STORAGE_KEYS} from "@/reference/modal-instruction-items";
  import ModalInstructions from "@/modals/modal-instructions/modal-instructions";
  import {Reference} from "smd-vue-scaffold";

  export default {
    name: "message-lab-request",
    mixins: [
      GetElementString,
      TitleMixin,
      ToastMixin,
      LabRequestCouponMixin,
      ShowModalInstructionsMixin
    ],
    props: {
      message: {type: Object, required: true},
      patient: {type: Object, required: true},
      token: {type: String, required: true},
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      ...mapGetters({
        doctorPatientPartner: GETTER_DOCTOR_PATIENT_PARTNER,
      }),
      isClaimed() {
        return !!this.message.orderid;
      },
      mainActionLabelId() {
        return this.isClaimed ? 'txt1423' : 'txt1411';
      },
      formattedTime() {
        return formatDate(this.message.date, 'hh:mm a');
      },
      enableActions() {
        return false;
      },
    },
    methods: {
      book() {
        if (this.loading) return;

        if (this.showModalInstructions(MODAL_LOCAL_STORAGE_KEYS.HIPRES)) {
          this.$modal.open({
            component: ModalInstructions,
            position: 'detached auto-height',
            props: {
              items: HIPRES_INSTRUCTION_ITEM,
              mainTitle: 'txt348',
              modalLocalStorageKey: MODAL_LOCAL_STORAGE_KEYS.HIPRES
            },
            onClose: ({success}) => {
              if (success) {
                this.claimCoupon(this.token, this.message.uploadid);
              }
            },
            size: Reference.SmdModalSizes.xs,
          })
        } else {
          this.claimCoupon(this.token, this.message.uploadid);
        }
      },
      viewPrescription() {
        if (this.loading) return;

        const {doctor} = this.doctorPatientPartner[this.token];
        const fileData = {...this.message, token: this.token, doctorname: doctor._fullName}
        this.$router.push(
          {
            name: Routes.CHAT_PREVIEW_LAB_REQUEST_FILE_ROUTE,
            params: {
              file: [fileData],
              title: this.computedTitle(fileData),
              type: PreviewFileType.PREVIEW_TYPE_LAB_REQUEST,
              [MESSAGE_DOCTOR_PARAM]: this.$route.params.doctor,
              [MESSAGE_PATIENT_ID_PARAM]: this.$route.params.patientId,
            },
          }
        )
      },
      goToServices() {
        this.$router.push({name: SERVICES_ROUTE});
      },
    },
    HpLogo
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .message-lab-request {
    @extend %layout--flex-col;
    background: color(gray-50);
    border-radius: radius(medium);
    padding: space(s) space(m);
    cursor: pointer;
    max-width: 372px;

    .smd-panel {
      padding: space(xs) space(s);
    }

    .actions {
      > button {
        width: 100%;

        &:first-child {
          @extend %layout--flex-row-center-xy;
          margin-bottom: space(s);

          .logo {
            width: 24px;
            height: 24px;
            margin-right: 5px;
            border-radius: 4px;
            background-color: color(white);

            > img {
              display: block;
              max-width: 100%;
            }
          }
        }
      }
    }

    .timestamp {
      margin-top: space(s);
    }
  }
</style>